<template>
    <div>
        <register-steps
            :steps="{1:'Gegevens',2:'Ervaringen',3:'Aan de slag!'}"
            totalAnswered="50"
            currentStep="1"
        />

        <div class="sd-title medium" style="margin-bottom: 20px;">
            <span class="steps">1/2</span>
            Aanmelden
        </div>

        <div>
            <span class="sd-notif warning text-left mt-2" style="margin-bottom: 15px; ">
              <svg-icon icon="information" class="warning-icon" />
                Welkom bij Derect! Top dat je een profiel gaat aanmaken. <br>
                Werken via Derect kan wanneer je de juiste diploma’s voor de zorg hebt. Heb je deze nog niet? Bel ons dan eerst even.
            </span>
        </div>

        <div class="input-row">
            <div class="sd-col-12 sd-input">
                <strong class="sd-title mini right-line">
                    <span class="title-text"><svg-icon icon="smiley" /> Jouw gegevens</span>
                </strong>
            </div>

            <div class="sd-col-6 sd-input">
                <label for="form-first-name">Voornaam<span class="required">*</span></label>
                <input
                    id="form-first-name"
                    type="text"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.firstname"
                    @input="update('firstname', $event.target.value)"
                    placeholder="Voornaam"
                    required
                />
            </div>

            <div class="sd-col-6 sd-input">
                <label for="form-last-name">Achternaam<span class="required">*</span></label>
                <input
                    id="form-last-name"
                    type="text"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.lastname"
                    @input="update('lastname', $event.target.value)"
                    placeholder="Achternaam"
                    required
                />
            </div>
        </div>

        <div class="input-row">
            <div class="sd-input sd-col-12">
                <label for="form-email">E-mailadres<span class="required">*</span></label>
                <input
                    id="form-email"
                    type="email"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.email"
                    @input="update('email', $event.target.value)"
                    placeholder="E-mailadres"
                    required
                />
            </div>
        </div>

        <div class="input-row">
            <div class="w-square-icon sd-input sd-col-12">
                <label for="form-password">Wachtwoord<span class="required">*</span></label>
                <div class="input-container">
                    <input
                        id="form-password"
                        :type="!pass1 ? 'password' : 'text'"
                        class="form-control"
                        autocomplete="nope"
                        :value="value.password"
                        @input="update('password', $event.target.value)"
                        placeholder="Wachtwoord"
                        required
                    />
                    <div
                        class="icon-wrapper eye position-absolute align-self-center"
                        v-on:click="pass1 = false"
                        v-if="pass1"
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <span><svg-icon icon="eye" /></span>
                    </div>
                    <div
                        class="icon-wrapper eye shown position-absolute align-self-center"
                        v-on:click="pass1 = true"
                        v-else
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <svg-icon icon="eye_hidden" />
                    </div>
                </div>
            </div>
        </div>

        <div class="input-row">
            <div class="w-square-icon sd-input sd-col-12">
                <label for="form-confirm-password">Bevestig wachtwoord<span class="required">*</span></label>
                <div class="input-container">
                    <input
                        id="form-confirm-password"
                        :type="!pass2 ? 'password' : 'text'"
                        class="form-control"
                        autocomplete="nope"
                        :value="value.password_confirmation"
                        @input="update('password_confirmation', $event.target.value)"
                        placeholder="Bevestig wachtwoord"
                        required
                    />
                    <div
                        class="icon-wrapper eye position-absolute align-self-center"
                        v-on:click="pass2 = false"
                        v-if="pass2"
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <span><svg-icon icon="eye" /></span>
                    </div>
                    <div
                        class="icon-wrapper eye shown position-absolute align-self-center"
                        v-on:click="pass2 = true"
                        v-else
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <svg-icon icon="eye_hidden" />
                    </div>
                </div>
            </div>
        </div>

        <div class="input-row">
            <div class="sd-col-12">
                <div class="sd-input">
                    <label for="form-mobile">Mobiel nummer<span class="required">*</span></label>
                    <input
                        id="form-mobile"
                        type="text"
                        class="form-control"
                        autocomplete="nope"
                        :value="value.mobile"
                        @input="update('mobile', $event.target.value)"
                        placeholder="Mobiel nummer"
                        required
                    />
                </div>
            </div>
        </div>

        <div class="input-row">
            <div class="sd-col-12">
                <p>
                    <strong class="sd-title mini right-line">
                        <span class="title-text"><svg-icon icon="address" /> Adresgegevens</span>
                    </strong>
                </p>

                <div class="input-row">
                    <div class="sd-col-12 sd-input">
                        <label for="form-street">Straat<span class="required">*</span></label>
                        <input
                            id="form-street"
                            type="text"
                            class="form-control"
                            autocomplete="nope"
                            :value="value.street"
                            @input="update('street', $event.target.value)"
                            placeholder="Straat"
                            required
                        />
                    </div>

                    <div class="sd-col-6 sd-input">
                        <label for="form-number">Nummer<span class="required">*</span></label>
                        <input
                            id="form-number"
                            type="text"
                            class="form-control"
                            autocomplete="nope"
                            :value="value.street_number"
                            @input="update('street_number', $event.target.value)"
                            placeholder="Nummer"
                            required
                        />
                    </div>

                    <div class="sd-col-6 sd-input">
                        <label for="form-addition">Toevoeging</label>
                        <input
                            id="form-addition"
                            type="text"
                            class="form-control"
                            autocomplete="nope"
                            :value="value.house_addition"
                            @input="update('house_addition', $event.target.value)"
                            placeholder="Toevoeging"
                            maxlength="7"
                        />
                    </div>
                </div>

                <div class="input-row">
                    <div class="sd-col-6 sd-input">
                        <label for="form-postal">Postcode<span class="required">*</span></label>
                        <input
                            id="form-postal"
                            type="text"
                            class="form-control"
                            autocomplete="nope"
                            :value="value.postal_code"
                            @input="update('postal_code', $event.target.value)"
                            placeholder="Postcode"
                            required
                        />
                    </div>

                    <div class="sd-col-6 sd-input">
                        <label for="form-place">Plaats<span class="required">*</span></label>
                        <input
                            id="form-place"
                            type="text"
                            class="form-control"
                            autocomplete="nope"
                            :value="value.city"
                            @input="update('city', $event.target.value)"
                            placeholder="Plaats"
                            required
                        />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            pass1: false,
            pass2: false,
        }
    },
    methods: {
        update(field, val) {
            this.$emit('input', {
                ...this.value,
                [field]: val
            })
        }
    }
}
</script>

<style scoped>

</style>